define('helperUser-customPoints',['jquery', 'config'], function($, config) {
    'use strict';

    var setCustomPoints = function setCustomPoints(trainingVM, points, overwrite) { //overwrite =  overwrite old points even if new points are lower

        if (!trainingVM.dataContext.previewMode) {

            getCurrentUserScore(trainingVM, function(resData) {

                if (resData.customPoints < points || overwrite) {

                    var postData = {
                        trainingId: trainingVM.dataContext.trainingID,
                        customPoints: points.toFixed(1)
                    };

                    $.ajax({
                        type: 'POST',
                        url: config.customPointsURL,
                        headers: {'Authorization-Token': trainingVM.dataContext.tokenID},
                        data: JSON.stringify(postData),
                        contentType: 'application/json; charset=utf-8',
                        dataType: 'json'
                    })
                        .done(function () {})
                        .fail(function () {
                            return false;
                        });
                }
            });
        }

        return true;

    };

    var getTopScoreLearners = function getTopScoreLearners(trainingVM, take, cbFunc) {

        var postData = {
            Id    : trainingVM.dataContext.trainingID,
            Take  : take
        };

        $.ajax({
            type: 'GET',
            url: config.topScoreURL,
            headers: {'Authorization-Token': trainingVM.dataContext.tokenID},
            cache: false,
            data: postData
        })
            .done(function( data ) {
                cbFunc(data);
            })
            .fail(function(  ) {
                return false;
            });

    };

    var getCurrentUserScore = function getCurrentUserScore(trainingVM, cbFunc) {

        if (!trainingVM.dataContext.previewMode) {

            var postData = {
                Id: trainingVM.dataContext.trainingID
            };

            $.ajax({
                type: 'GET',
                url: config.userScoreURL,
                headers: {'Authorization-Token': trainingVM.dataContext.tokenID},
                cache: false,
                data: postData
            })
                .done(function (data) {
                    cbFunc(data);
                })
                .fail(function () {
                    return false;
                });
        }
    };

    return {
        setCustomPoints:setCustomPoints,
        getTopScoreLearners: getTopScoreLearners,
        getCurrentUserScore: getCurrentUserScore
    };
});

